import { t } from 'i18next';
import { INVOICE_STATUS } from 'shared/constants/invoices/statuses';
import { VAT_DESCRIPTION } from 'shared/constants/invoiceVatDescription';
import { InvoiceModel } from 'shared/types/Invoice';

import { COLOR } from '@/theme/colors';

import { isFutureDate, overdueDaysCalculation } from './date';

// TODO: make isUSUser argument more generic
export const calculateInvoiceVATLabel = (
    invoice: InvoiceModel,
    isUSUser: boolean,
): string => {
    const _vatDescription = {
        [VAT_DESCRIPTION.WITH_VAT]: t('Invoicing:includingGST', {
            defaultValue: 'Including GST',
        }),
        [VAT_DESCRIPTION.WITHOUT_VAT]: t('Invoicing:excludingGST', {
            defaultValue: 'Excluding GST',
        }),
        [VAT_DESCRIPTION.INCLUDING_TAX]: t('Invoicing:includingTax'),
        [VAT_DESCRIPTION.EXCLUDING_TAX]: t('Invoicing:excludingTax'),
    };

    let vatText;
    let invoiceLabel;

    if (invoice.applyTaxes) {
        invoiceLabel = `${t('Invoicing:total')}`;
        vatText = isUSUser
            ? VAT_DESCRIPTION.INCLUDING_TAX
            : VAT_DESCRIPTION.WITH_VAT;
    } else {
        invoiceLabel = `${t('Invoicing:subTotal')}`;
        vatText = isUSUser
            ? VAT_DESCRIPTION.EXCLUDING_TAX
            : VAT_DESCRIPTION.WITHOUT_VAT;
    }

    return `${invoiceLabel} ${_vatDescription[vatText]}`;
};

export const calculateInvoicePriceSum = ({
    priceSum,
    invoice,
    currency,
}: {
    priceSum: number;
    invoice: InvoiceModel;
    currency: string;
}): string => {
    let price = '';

    const invoiceTotal = invoice && invoice.total && Number(invoice.total);

    if (typeof invoiceTotal === 'number' && !isNaN(invoiceTotal)) {
        price = `${currency ? currency : '$'} ${invoiceTotal.toFixed(2)}`;
    } else {
        price = `${currency ? currency : '$'} ${priceSum.toFixed(2)}`;
    }
    return price;
};

export const calculateOverdue = (
    overdueDate: string,
    isDateInTheFuture: boolean,
): string => {
    const overdueDays = overdueDaysCalculation(overdueDate);

    if (overdueDays === -1) {
        return '-';
    } else {
        return `${overdueDays.toFixed(0)} ${t('InvoicesPage:days')} ${
            !isDateInTheFuture ? t('InvoicesPage:ago') : ''
        }`;
    }
};

export const getOverdueColor = (dueDateTime: string) => {
    const isDateInTheFuture = isFutureDate(dueDateTime);

    return isDateInTheFuture ? COLOR.warningYellow : COLOR.errorRed;
};

export const getOverdueWithColor = (
    dueDateTime: string,
    status: string,
): { value: string; color: string } => {
    if (status === INVOICE_STATUS.paid) {
        return { value: '-', color: COLOR.white };
    }

    return {
        value: calculateOverdue(dueDateTime, isFutureDate(dueDateTime)),
        color: getOverdueColor(dueDateTime),
    };
};
